import { useState } from "react";
import { PageHeader } from "@/components/PageHeader";
import { ProjectCard } from "@/components/ProjectCard";
import { Reveal } from "@/components/Reveal";
import { useProjects } from "@/hooks/useData";

export default function Projects() {
  const { data: projects = [], isLoading } = useProjects();
  const [filter, setFilter] = useState("All");

  const types = ["All", ...Array.from(new Set(projects.map((p) => p.category).filter(Boolean)))];
  const filtered = filter === "All" ? projects : projects.filter((p) => p.category === filter);

  return (
    <div data-testid="projects-page">
      <PageHeader eyebrow="Client References" title="Projects realised" accent="worldwide." description="From private villas to hospitality and commercial fit-outs — a selection of the spaces we have helped bring to life." />
      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-12 sm:py-16">
        <div className="flex flex-wrap gap-3 mb-12">
          {types.map((t) => (
            <button
              key={t}
              onClick={() => setFilter(t)}
              data-testid={`project-filter-${t.toLowerCase().replace(/ /g, "-")}`}
              className={`label-eyebrow text-[10px] px-5 py-2.5 border transition-colors ${
                filter === t ? "bg-[#2C2A29] text-[#FFFFFF] border-[#2C2A29]" : "bg-transparent text-[#5E5A54] border-[#ECEAE4] hover:border-[#9E8773]"
              }`}
            >
              {t}
            </button>
          ))}
        </div>
        {isLoading ? (
          <p className="text-[#5E5A54] font-light">Loading…</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {filtered.map((p, i) => (
              <Reveal key={p.id} delay={(i % 3) * 0.06}>
                <ProjectCard project={p} />
              </Reveal>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
